import React, { FC } from 'react';
import { Trans } from 'react-i18next';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Typography from '@mui/material/Typography';

import { Button, Dialog } from 'components';
import { PermissionGroupDetailModel } from 'models';

import { usePermissionGroupNotifications } from './usePermissionGroupNotifications';

export interface PermissionGroupNotificationsDialogProps {
  group: PermissionGroupDetailModel;
  open: boolean;
  onClose: () => void;
  canEdit: boolean;
}

export const PermissionGroupNotificationsDialog: FC<PermissionGroupNotificationsDialogProps> = ({
  group,
  open,
  onClose,
  canEdit,
}) => {
  const { notificationCatalogue, selected, handleToggle, resetSelection, isDirty, isPending, handleSave } =
    usePermissionGroupNotifications(group);

  const handleCancel = () => {
    resetSelection();
    onClose();
  };

  const handleSubmit = async () => {
    await handleSave();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      title={<Trans i18nKey="KOZOS_JOGOSULTSAGI_CSOPORTOK.NOTIFICATIONS_DIALOG_TITLE" />}
      actions={
        <Box display="flex" gap={2}>
          <Button variant="outlined" onClick={handleCancel}>
            <Trans i18nKey="COMMON.CANCEL" />
          </Button>
          <Button onClick={handleSubmit} disabled={!canEdit || !isDirty} loading={isPending}>
            <Trans i18nKey="COMMON.OK" />
          </Button>
        </Box>
      }
    >
      <Typography variant="body2" color="text.secondary" mb={1}>
        <Trans i18nKey="KOZOS_JOGOSULTSAGI_CSOPORTOK.NOTIFICATIONS_SECTION_DESCRIPTION" />
      </Typography>
      <FormGroup>
        {notificationCatalogue.map((entry) => (
          <FormControlLabel
            key={entry.code}
            control={
              <Checkbox
                checked={selected.has(entry.code)}
                disabled={!canEdit}
                onChange={(_e, checked) => handleToggle(entry.code, checked)}
              />
            }
            label={entry.label}
          />
        ))}
      </FormGroup>
    </Dialog>
  );
};

export default PermissionGroupNotificationsDialog;
